import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CorporateAccountService, GeneralService, IUser } from '@clooper/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-extra-service-removal',
  templateUrl: './extra-service-removal.component.html',
  styleUrls: ['./extra-service-removal.component.scss']
})
export class ExtraServiceRemovalComponent implements OnInit {

  user: IUser | undefined

  form = new FormGroup({
    location_of_items: new FormControl('', [Validators.required]),
    destination_of_items: new FormControl('', [Validators.required]),
    additional_requests: new FormControl('', []),
    packing_and_transportation_arrangements: new FormControl('', [Validators.required]),
    item_types: new FormControl([], [Validators.required]),
  });
  locationName: any;
  booking: any;
  itemTypes: [{name: '', label: '', checked: false}]
  otherFacilitiesData = {
    form: { label: 'Item Types', placeholder: 'Enter specific item that needs to be removed' },
    caption: 'Enter specific item that needs to be removed'
  }
  loading: boolean = false

  constructor(
    public bsModalRef: BsModalRef,
    private options: ModalOptions,
    private service: CorporateAccountService,
    private toastr: ToastrService,
    private gs: GeneralService,

  ) { }

  ngOnInit(): void {
    this.user = this.options.initialState?.user as IUser

    this.booking = this.options.initialState?.booking

  }

  locationChangeF({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    this.form.controls.location_of_items.setValue(s);

  }

  locationChangeT({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    this.form.controls.destination_of_items.setValue(s);

  }

  getRemovedRule(event: string) {
    this.itemTypes.some((element: {name: string, checked: boolean}) => {
      if (element.name.includes(event)) {
        element.checked = false
      }
    })
  }

  locationChangeJ({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    this.form.controls.destination.setValue(s);

  }

  submit() {
    this.loading = true
    const {location_of_items,destination_of_items, item_types, additional_requests, packing_and_transportation_arrangements} = this.form.value;

    const payload = {
      location_of_items,
      destination_of_items,
      additional_requests,
      item_types,
      packing_and_transportation_arrangements,
      // destination,
      // vehicle_type,
      employee: this.user?.id || this.user?._id,
      business: this.user?.business?.id || this.user?.business?._id,
      booking: this.booking

    }
    if (this.booking !== null) {
      this.service.createExtraServiceRemoval(payload).subscribe((res: any) => {
          this.toastr.success(res.message)
          this.bsModalRef.hide()
      }, err => {
        this.toastr.error(this.gs.getErrMsg(err));
        this.loading = false

        // this.bsModalRef.hide()
      })
    } else {
      delete payload.booking
      this.service.createExtraServiceRemoval(payload).subscribe((res: any) => {
          this.toastr.success(res.message)
          this.bsModalRef.hide()
      }, err => {
        this.toastr.error(this.gs.getErrMsg(err));
        this.loading = false

        // this.bsModalRef.hide()
      })

    }
  }

}
